import React from "react";
import { Footer, Navbar } from "../components";

const categories = [
  {
    title: "Templates",
    image:
      "https://images.pexels.com/photos/196644/pexels-photo-196644.jpeg?auto=compress&cs=tinysrgb&w=1200",
    href: "/product?cat=men's clothing",
  },
  {
    title: "Ebooks",
    image:
      "https://images.pexels.com/photos/7679720/pexels-photo-7679720.jpeg?auto=compress&cs=tinysrgb&w=1200",
    href: "/product?cat=women's clothing",
  },
  {
    title: "Courses",
    image:
      "https://images.pexels.com/photos/1181675/pexels-photo-1181675.jpeg?auto=compress&cs=tinysrgb&w=1200",
    href: "/product?cat=jewelery",
  },
  {
    title: "Software",
    image:
      "https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg?auto=compress&cs=tinysrgb&w=1200",
    href: "/product?cat=electronics",
  },
];

const values = [
  {
    title: "Premium Quality",
    desc: "Aset digital terkurasi dengan standar industri tertinggi.",
  },
  {
    title: "Instant Access",
    desc: "Langsung download file aset setelah pembayaran berhasil.",
  },
  {
    title: "Secure Payment",
    desc: "Transaksi aman dengan berbagai pilihan metode pembayaran.",
  },
  {
    title: "Lifetime Updates",
    desc: "Dapatkan update gratis selamanya untuk setiap aset yang dibeli.",
  },
];

const stats = [
  { label: "Assets", value: "10K+" },
  { label: "Creators", value: "500+" },
  { label: "Downloads", value: "1M+" },
  { label: "Rating", value: "4.9/5" },
];

const AboutPage = () => {
  return (
    <>
      <Navbar />

      <main className="min-h-screen bg-black text-white">
        {/* HERO */}
        <section className="relative overflow-hidden">
          {/* Background glow */}
          <div className="pointer-events-none absolute inset-0">
            <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
            <div className="absolute -bottom-28 -left-28 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
          </div>

          <div className="mx-auto max-w-6xl px-4 py-12 sm:py-16 relative">
            <div className="grid items-center gap-10 lg:grid-cols-2">
              <div>
                <p className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs font-medium text-white">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
                  Digital Marketplace
                </p>

                <h1 className="mt-4 text-3xl font-semibold tracking-tight sm:text-4xl lg:text-5xl">
                  Empowering Creators
                </h1>

                <p className="mt-4 text-base leading-relaxed text-white/70 sm:text-lg">
                  Hyperstore menyediakan ribuan aset digital premium untuk
                  mempercepat workflow project kreatifmu. Dari template, ebook,
                  hingga course.
                </p>

                <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                  <a
                    href="/products"
                    className="inline-flex items-center justify-center rounded-xl bg-white px-5 py-3 text-sm font-semibold text-black shadow-sm transition hover:bg-white/90"
                  >
                    Explore Assets
                  </a>
                  <a
                    href="/contact"
                    className="inline-flex items-center justify-center rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-white/10"
                  >
                    Contact Us
                  </a>
                </div>
              </div>

              {/* Hero Card */}
              <div className="rounded-3xl border border-white/10 bg-white/5 p-4 shadow-sm backdrop-blur">
                <div className="grid gap-4 sm:grid-cols-2">
                  <div className="rounded-2xl border border-white/10 bg-black/40 p-4">
                    <p className="text-sm font-medium">Why creators love us</p>
                    <p className="mt-2 text-sm text-white/70">
                      Aset berkualitas tinggi yang siap pakai, hemat waktu & tenaga.
                    </p>
                  </div>
                  <div className="rounded-2xl border border-white/10 bg-black/40 p-4">
                    <p className="text-sm font-medium">Instant Download</p>
                    <p className="mt-2 text-sm text-white/70">
                      Akses file langsung tepat setelah pembayaran dikonfirmasi.
                    </p>
                  </div>

                  <div className="sm:col-span-2 overflow-hidden rounded-2xl border border-white/10">
                    <img
                      src="https://images.pexels.com/photos/1779487/pexels-photo-1779487.jpeg?auto=compress&cs=tinysrgb&w=1200"
                      alt="Digital Workspace"
                      className="h-56 w-full object-cover sm:h-64"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* STATS */}
            <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-2xl border border-white/10 bg-white/5 p-5 shadow-sm backdrop-blur"
                >
                  <p className="text-2xl font-semibold">{s.value}</p>
                  <p className="mt-1 text-sm text-white/70">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* VALUES */}
        <section className="mx-auto max-w-6xl px-4 py-12">
          <h2 className="text-2xl font-semibold sm:text-3xl">
            What we stand for
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-white/70 sm:text-base">
            Kami berdedikasi membantu kreator dan developer membangun project lebih cepat.
          </p>

          <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v) => (
              <div
                key={v.title}
                className="rounded-2xl border border-white/10 bg-white/5 p-5 shadow-sm backdrop-blur transition hover:bg-white/10"
              >
                <div className="mb-3 h-10 w-10 rounded-xl bg-white/10" />
                <h3 className="text-base font-semibold">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/70">
                  {v.desc}
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* CATEGORIES */}
        <section className="mx-auto max-w-6xl px-4 pb-12">
          <div className="flex items-end justify-between gap-6">
            <div>
              <h2 className="text-2xl font-semibold sm:text-3xl">
                Shop by category
              </h2>
              <p className="mt-2 max-w-2xl text-sm text-white/70 sm:text-base">
                Cari aset yang sesuai kebutuhan project-mu dengan mudah.
              </p>
            </div>
            <a
              href="/categories"
              className="hidden text-sm font-semibold text-white/80 hover:text-white hover:underline sm:inline"
            >
              View all
            </a>
          </div>

          <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {categories.map((c) => (
              <a
                key={c.title}
                href={c.href}
                className="group overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-sm backdrop-blur transition hover:bg-white/10"
              >
                <div className="relative">
                  <img
                    src={c.image}
                    alt={c.title}
                    className="h-44 w-full object-cover transition duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold">{c.title}</h3>
                  <p className="mt-1 text-xs text-white/70">
                    Explore best picks →
                  </p>
                </div>
              </a>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="mx-auto max-w-6xl px-4 pb-16">
          <div className="rounded-3xl border border-white/10 bg-gradient-to-r from-white/10 to-white/5 p-6 shadow-sm backdrop-blur sm:p-10">
            <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
              <div>
                <h2 className="text-2xl font-semibold sm:text-3xl">
                  Ready to boost your workflow?
                </h2>
                <p className="mt-2 max-w-2xl text-sm text-white/70 sm:text-base">
                  Temukan ribuan aset digital premium dan mulai berkreasi
                  tanpa batas.
                </p>
              </div>
              <div className="flex flex-col gap-3 sm:flex-row">
                <a
                  href="/products"
                  className="inline-flex items-center justify-center rounded-xl bg-white px-5 py-3 text-sm font-semibold text-black shadow-sm transition hover:bg-white/90"
                >
                  Explore Now
                </a>
                <a
                  href="/signup"
                  className="inline-flex items-center justify-center rounded-xl border border-white/15 bg-white/5 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-white/10"
                >
                  Create Account
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default AboutPage;
